export default {
  "art.e11577": "art.E11577",
  "art.e11597": "art.E11597",
  "art.e11598": "art.E11598",
};
